import { render, staticRenderFns } from "./DrugDetail.vue?vue&type=template&id=e72a86fa&scoped=true"
import script from "./DrugDetail.vue?vue&type=script&lang=js"
export * from "./DrugDetail.vue?vue&type=script&lang=js"
import style0 from "./DrugDetail.vue?vue&type=style&index=0&id=e72a86fa&prod&scoped=true&lang=css"
import style1 from "./DrugDetail.vue?vue&type=style&index=1&id=e72a86fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72a86fa",
  null
  
)

export default component.exports